import { useLocation } from "react-router-dom";
import { usePwaUpdate } from "../../hooks/usePwaUpdate";
import OverlayRoot from "./OverlayRoot";

function isAuthCallbackPath(pathname: string): boolean {
  return pathname.startsWith("/auth/callback/") || pathname.startsWith("/auth/app-callback/");
}

export default function PwaUpdateToast() {
  const { pathname } = useLocation();
  const { needRefresh, applyUpdate, dismiss } = usePwaUpdate();

  if (!needRefresh || isAuthCallbackPath(pathname)) {
    return null;
  }

  return (
    <OverlayRoot
      data-section="pwa-update-toast"
      isolate="contain"
      portal
      className="fixed bottom-24 left-1/2 z-[70] w-[min(420px,calc(100vw-2rem))] -translate-x-1/2"
      role="status"
      aria-live="polite"
    >
      <div className="flex items-center justify-between gap-3 rounded-2xl border border-white/15 bg-black/60 px-4 py-3 shadow-2xl backdrop-blur-xl">
        <p className="text-sm font-medium text-white">A new version is available</p>
        <div className="flex flex-shrink-0 items-center gap-2">
          <button
            type="button"
            onClick={dismiss}
            className="rounded-lg px-2 py-1 text-xs text-gray-200 transition-all hover:bg-white/10 hover:text-white"
          >
            Later
          </button>
          <button
            type="button"
            onClick={applyUpdate}
            className="rounded-lg bg-white/15 px-3 py-1.5 text-xs font-semibold text-white transition-all hover:bg-white/25"
          >
            Reload
          </button>
        </div>
      </div>
    </OverlayRoot>
  );
}
